module.exports = __webpack_public_path__ + "static/media/cart.bfb395e9.svg";